import { getAuthTokens } from '@/storage/auth-tokens.storage';
import { authStore, resolveAuthenticatedUser } from '@/store/auth.store';
import { getLogger } from '@/logger/logger';

const logger = getLogger('auth-init');

export async function initializeAuth(): Promise<void> {
  logger.info('Initializing auth...');

  const tokens = getAuthTokens();

  if (!tokens?.access_token) {
    logger.info('No token found, setting unauthenticated');
    authStore.setState({ authStatus: 'unauthenticated' });
    return;
  }

  logger.info('Token found, loading user...');
  authStore.setState({ authStatus: 'loading' });

  try {
    await resolveAuthenticatedUser(tokens.access_token);
    const state = authStore.getState();
    if (state.authenticatedUser) {
      logger.info('User loaded successfully', { userId: state.authenticatedUser.id });
    } else {
      logger.warn('Token valid but no user returned');
      authStore.setState({ authStatus: 'unauthenticated' });
    }
  } catch (error) {
    logger.error('Failed to load user', {}, error);
    authStore.setState({ authStatus: 'unauthenticated' });
  }
}
